import { computed, makeObservable } from 'mobx'
import { formatToLongDateWithComma } from 'utils/date-util'
import { JobNote } from 'jobs/notes/JobNote'
import { Id } from 'types/definitions'

const NOTE_AUTHOR_ROLE_LABELS: Record<string, string> = {
  Provider: 'Pro',
  'Internal Taxfyle Team': 'Admin',
  'Relationship Manager': 'RM',
  'Firm Admin': 'Partner',
  'Firm Ally': 'Ally',
}

export default class JobNoteItemViewModel {
  constructor(
    private note: JobNote,
    private readonly getMentionLabel: (
      userPublicId: Id,
    ) => string | undefined,
  ) {
    makeObservable(this)
  }

  @computed
  get id() {
    return this.note.id
  }

  @computed
  get author() {
    return this.note.author
  }

  @computed
  get displayName() {
    return this.author.displayName
  }

  @computed
  get role(): string | undefined {
    return this.author.roles
      .map((r) => NOTE_AUTHOR_ROLE_LABELS[r.name.trim()])
      .find(Boolean)
  }

  @computed
  get formattedTime() {
    const date = this.note.dateCreated
    const now = new Date()
    const isToday =
      date.getFullYear() === now.getFullYear() &&
      date.getMonth() === now.getMonth() &&
      date.getDate() === now.getDate()

    if (isToday) {
      const time = date.toLocaleTimeString([], {
        hour: 'numeric',
        minute: '2-digit',
      })
      return `Today, ${time}`
    }

    return formatToLongDateWithComma(date)
  }

  @computed
  get body() {
    return this.note.body
  }

  @computed
  get mentions(): string[] {
    return this.note.recipientUserPublicIds
      .map((id) => this.getMentionLabel(id))
      .filter((label): label is string => !!label)
  }
}
